export const getters = {
  artist: state => state.artist,
  song: state => state.song,
  loading: state => state.loading,
  error: state => state.erorr,
  nowPlaying: state => `${state.song} by ${state.artist}`
};
